<script setup lang="ts">
import { ref } from "vue";
import { useClipboard } from "@vueuse/core";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, Check, ExternalLink } from "lucide-vue-next";

interface Props {
    bookingUrl: string;
}

const props = defineProps<Props>();

const { copy, copied, isSupported } = useClipboard();

function copyUrl() {
    copy(props.bookingUrl);
}

function openInNewTab() {
    window.open(props.bookingUrl, "_blank");
}
</script>

<template>
    <div class="space-y-6">
        <div>
            <label class="mb-2 text-sm font-medium text-iron-700 block">
                {{ $t("event_types.share_hub.share.booking_url") }}
            </label>
            <div class="gap-2 flex">
                <Input
                    :model-value="bookingUrl"
                    readonly
                    class="bg-iron-50 font-mono text-sm flex-1"
                />
                <Button
                    v-if="isSupported"
                    variant="outline"
                    @click="copyUrl"
                    class="gap-2 shrink-0"
                >
                    <Check v-if="copied" :size="16" />
                    <Copy v-else :size="16" />
                    {{ copied ? $t("copied") : $t("copy") }}
                </Button>
            </div>
            <p class="mt-2 text-sm text-iron-500">
                {{ $t("event_types.share_hub.share.booking_url_description") }}
            </p>
        </div>

        <div class="pt-4 border-iron-200 border-t">
            <Button variant="outline" @click="openInNewTab" class="gap-2">
                <ExternalLink :size="16" />
                {{ $t("event_types.share_hub.share.open_in_new_tab") }}
            </Button>
        </div>
    </div>
</template>
